/**
 * Check if an error is a 403 Forbidden error
 * @param {Error|Object} error - The error object
 * @returns {boolean} - True if the error is a 403 error
 */
export const isForbiddenError = (error) => {
  if (!error) return false;

  // Check HTTP status
  if (error.status === 403) return true;

  // Check response status
  if (error.response?.status === 403) return true;

  // Check for ACCESS_DENIED code
  if (error.code === 'ACCESS_DENIED') return true;
  if (error.response?.body?.code === 'ACCESS_DENIED') return true;

  return false;
};

/**
 * Check if an error is an authentication error (401)
 * @param {Error|Object} error - The error object
 * @returns {boolean} - True if the error is a 401 error
 */
export const isUnauthorizedError = (error) => {
  if (!error) return false;

  // Check HTTP status
  if (error.status === 401) return true;

  // Check response status
  if (error.response?.status === 401) return true;

  // Check for unauthorized message
  if (error.message === 'Unauthorized') return true;

  return false;
};

/**
 * Get error message from error object
 * @param {Error|Object} error - The error object
 * @returns {string} - The error message
 */
export const getErrorMessage = (error) => {
  if (!error) return '';

  // Try different error message locations
  if (error.message) return error.message;
  if (error.response?.body?.message) return error.response.body.message;
  if (error.response?.body?.error_description) return error.response.body.error_description;
  if (error.response?.body?.error) return error.response.body.error;

  return 'An error occurred';
};

/**
 * Get error code from error object
 * @param {Error|Object} error - The error object
 * @returns {string|null} - The error code
 */
export const getErrorCode = (error) => {
  if (!error) return null;

  // Try different error code locations
  if (error.code) return error.code;
  if (error.response?.body?.code) return error.response.body.code;
  if (error.response?.body?.error) return error.response.body.error;

  return null;
};
